import resetReduxAction from 'modules/redux/actions/reset'
import validateReduxAction from 'modules/redux/actions/validate'
import {
  TRAINING_AUTH_ACTION,
  TRAINING_AUTH_DOMAIN
} from 'modules/training/modules/app-auth/constants'

function resetTrainingAuthAction () {
  return (dispatch) => {
    dispatch(
      resetReduxAction({
        type: TRAINING_AUTH_ACTION.RESET_STATE,
        payload: {
          path: TRAINING_AUTH_DOMAIN
        }
      })
    )
    dispatch(
      validateReduxAction({
        type: TRAINING_AUTH_ACTION.VALIDATE_EMAIL_AND_PASSWORD,
        payload: {
          path: TRAINING_AUTH_DOMAIN
        }
      })
    )
  }
}

export default resetTrainingAuthAction
